import { Modal } from '@components/ui';
import { useAppSelector } from '@hooks/app/redux';
import usePendingActionsRefresher from '@hooks/query/pendingActions/usePendingActionsRefresher';
import { addToMyClients, removeFromMyClients } from '@services/external/client.api';
import { actions } from '@store/ducks/patients';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { TWaiting } from 'types/patients';
import TStore from 'types/store';
import PatientRequest from '../../../patient-request';
import FeedCardHeader from '../../feed-card-header';
import { FeedPatientsSC } from '../../feed.styled';
import PatientRejectModal from './components/patient-reject-modal';
import FeedNoPatients from './feed-no-patients';

type TProps = {} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const FeedPatients: React.FC<TProps> = ({ waiting, getWaitingRequest }) => {
  const { formatMessage } = useIntl();
  const [timer, setTimer] = useState<ReturnType<typeof setInterval> | null>(null);
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;
  const { refetch } = usePendingActionsRefresher();

  useEffect(() => {
    if (timer === null) {
      getWaitingRequest();
      const t = setInterval(getWaitingRequest, 4000);
      setTimer(t);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [getWaitingRequest, setTimer, timer]);

  const onAction = () => {
    getWaitingRequest();
    refetch(['base', 'overview']);
    // stop interval for 8s to show alert
    if (timer) {
      clearInterval(timer);
      setTimeout(() => {
        const t = setInterval(getWaitingRequest, 4000);
        setTimer(t);
      }, 4000);
    }
  };

  const onAccept = React.useCallback(async (waiting: TWaiting) => {
    await addToMyClients(providerId, waiting.client.id);
    onAction();
  }, []);

  const removeModal = Modal.useModal<TWaiting>();
  const onRemove = React.useCallback(async (waiting: TWaiting) => {
    await removeFromMyClients(providerId, waiting.client.id);
    onAction();
    removeModal.close();
  }, []);

  if (waiting?.items.length === 0) {
    return <FeedNoPatients />;
  }

  return (
    <>
      <FeedPatientsSC className="feed-card">
        {/* <FeedIcon>
          <img
            src={require('@assets/svg/icon-new-patients.svg').default}
            width="24s"
            height="25"
            alt=""
          />
        </FeedIcon> */}
        <FeedCardHeader
          title={`${formatMessage({ id: 'patients.incoming_requests' })} (${
            waiting?.pagination.total ?? 0
          })`}
        />

        <div className="body">
          {waiting?.items.map((request) => (
            <PatientRequest
              waiting={request}
              key={request.id}
              onAccept={onAccept}
              onReject={(w) => removeModal.open(undefined, w)}
            />
          ))}
        </div>
      </FeedPatientsSC>
      <PatientRejectModal
        {...removeModal.modalProps}
        onRemove={onRemove}
        onClose={removeModal.close}
        item={removeModal.data}
      />
    </>
  );
};

const mapStateToProps = (state: TStore) => ({
  waiting: state.patients.waiting,
});

const mapDispatchToProps = (dispatch: any) => ({
  getWaitingRequest: () => dispatch(actions.getWaitingRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedPatients);
